/* BJD Fan Arcade — shared frontend logic (dev build 2026-07-04).
   Talks to chirp-api. Config injected by the bjd-arcade-gate snippet as window.BJD_ARCADE. */
(function () {
  "use strict";
  if (window.__BJDA_LOADED) return; // both sections load this asset — run once
  window.__BJDA_LOADED = true;
  var CFG = window.BJD_ARCADE;
  if (!CFG) return;

  // ---- anon identity bootstrap (2026-08-07, cid-collapse fix) ----
  // bjd-arcade-gate.liquid mints cid = "anon-" + cart.token for a signed-out
  // fan. That comment (and this file's prior assumption) claimed Shopify
  // hands every visitor a cart.token with zero interaction — FALSE, verified
  // 2026-08-07 against a real cold browser tab (no `cart` cookie present at
  // all until something actually touches the cart; community + our own
  // ground-truth agree cart.token is add-to-cart-triggered, not visit-
  // triggered). Every genuine first-time fan gets the literal string "anon-"
  // — one shared rate-limit bucket, one shared consent record once consent
  // ships. Liquid can't mint a better id at render time (no cookie-read API
  // in standard theme Liquid), so the fix lives here: anchor identity in
  // localStorage (survives hard refresh, same trade-off class the consent
  // cache below already accepts) and get chirp-api to sign it — same
  // HMAC_SECRET the server already holds to verify every other call, so no
  // new secret exposure. CFG.cid/CFG.sig are mutated IN PLACE on the same
  // object every api() call reads at call time, so this never needs to touch
  // the loggedIn gates below (those must stay synchronous or the whole
  // Chirp Me / Rank My Flow init block never runs). A stray call fired in
  // the sub-second window before the mint resolves still works — it just
  // uses the shared bootstrap id (server-side, degrades safely, never
  // errors). Customers (CFG.isCustomer) are completely untouched.
  (function bootstrapAnonIdentity() {
    if (!CFG.loggedIn || CFG.isCustomer) return; // real customer id — Liquid's mint stands
    if (CFG.cid !== "anon-") return; // cart.token WAS present — Liquid already minted a real id
    var STORE_KEY = "bjda_anon_v1";
    try {
      var cached = JSON.parse(localStorage.getItem(STORE_KEY) || "null");
      if (cached && cached.cid && cached.sig) {
        CFG.cid = cached.cid; CFG.sig = cached.sig;
        return; // repeat visit / hard refresh — same identity, zero network round trip
      }
    } catch (e) {}
    var rand = (window.crypto && crypto.randomUUID) ? crypto.randomUUID()
      : (Date.now().toString(36) + Math.random().toString(36).slice(2, 12) + Math.random().toString(36).slice(2, 12));
    var candidate = "anon-" + String(rand).replace(/[^A-Za-z0-9_-]/g, "").slice(0, 48);
    fetch(CFG.api + "/api/anon-session", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ cid: candidate }),
    }).then(function (r) { return r.json(); }).then(function (j) {
      if (!j || !j.cid || !j.sig) return; // mint failed — CFG keeps the shared bootstrap id, safe degrade
      CFG.cid = j.cid; CFG.sig = j.sig;
      try { localStorage.setItem(STORE_KEY, JSON.stringify(j)); } catch (e) {}
    }).catch(function () {});
  })();


  // Anon -> account merge (2026-08-19, Phase 5, operator-ruled "FIX IT"): a
  // fan who played signed-out and then created an account carries their
  // points, handle and cards across. The browser still holds the cached anon
  // identity; once we're a real customer, hand it to the server to merge and
  // clear the cache on success. Runs once per page load, no-ops in the
  // common cases (not a customer / no cached anon identity / already merged).
  (function mergeAnonOnLogin() {
    if (!CFG.isCustomer) return;
    var cached = null;
    try { cached = JSON.parse(localStorage.getItem("bjda_anon_v1") || "null"); } catch (e) {}
    if (!cached || !cached.cid || !cached.sig) return;
    api("/api/merge-anon", { anon_cid: cached.cid, anon_sig: cached.sig }).then(function (r) {
      // 404 = an older backend without the endpoint: keep the cache, retry on
      // a later visit once the backend has it. Only a real success clears it.
      if (r.status === 200 && r.body && r.body.ok) {
        try { localStorage.removeItem("bjda_anon_v1"); } catch (e) {}
        if (r.body.fan_rank) renderFanRank(r.body.fan_rank);
      }
    }).catch(function () {});
  })();

  function api(path, body, extraHeaders) {
    var headers = { "content-type": "application/json" };
    if (extraHeaders) for (var k in extraHeaders) headers[k] = extraHeaders[k];
    return fetch(CFG.api + path, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(Object.assign({ cid: CFG.cid, email: CFG.email, name: CFG.name, sig: CFG.sig }, body || {})),
    }).then(function (r) { return r.json().then(function (j) { return { status: r.status, body: j }; }); });
  }

  function $(sel, root) { return (root || document).querySelector(sel); }
  function show(el) { el && el.classList.remove("bjda-hide"); }
  function hide(el) { el && el.classList.add("bjda-hide"); }
  function setStatus(root, msg, isErr) {
    var el = $(".bjda-status", root);
    if (el) { el.textContent = msg || ""; el.classList.toggle("err", !!isErr); }
  }

  var player = null;
  function playAudio(b64, waveEl) {
    if (player) { player.pause(); player = null; }
    if (!b64) return;
    player = new Audio("data:audio/mpeg;base64," + b64);
    if (waveEl) {
      waveEl.classList.remove("paused");
      player.addEventListener("ended", function () { waveEl.classList.add("paused"); });
      player.addEventListener("pause", function () { waveEl.classList.add("paused"); });
    }
    player.play().catch(function () { /* user can hit replay */ });
  }

  // Scores are 0-10 with one decimal (operator's scale, 7/08).
  // Ladder OPERATOR-LOCKED 2026-08-07 11:08 AM CT (canon-card-bjd.md) — this
  // client-side fallback still read the pre-lock placeholder names until
  // 2026-08-08. It is the ONLY source for the salad-status text baked into
  // the shareable card PNG (shareCard() never receives server's salad_status,
  // only the numeric score — see the two shareCard() calls for Rank My Flow),
  // so this was shipping the wrong ladder on the one surface built to leave
  // the site. Server-side lib is server.js saladStatus() (0-100 scale) —
  // same lock, same fix, matching thresholds on this 0-10 scale.
  // Hall of Flow gate lowered 9 -> 8, 2026-08-10 10:55 PM CT — operator ruling
  // 9:56 PM CT supersedes the 8/07 90/9 lock. Edited in the SAME session as
  // server.js's matching 90->80 change so the two implementations of one rule
  // (0-100 vs 0-10 scale) don't silently disagree. NOT pushed to any theme —
  // repo-only per tonight's scope; go-live push is a separate, unauthorized step.
  // Hall of Flow gate re-lowered 8 -> 7.5, 2026-08-11 — ratio-matched to
  // server.js's 75/100 recalibration against gpt-5.4-mini's real output
  // distribution (same edit session, same reasoning — full derivation at
  // rank-my-flow-hair-cuts/batch7-all/HALL-OF-FLOW-THRESHOLD-RECAL-2026-08-11.md).
  //
  // 🔴 DISPLAY/GATE DECOUPLE (2026-08-11, pre-publish defect fix) — matches
  // server.js's HALL_OF_FLOW_GATE / HALL_OF_FLOW_DISPLAY split, same edit
  // session. GATE is the model-calibration threshold (tunes with the judge).
  // DISPLAY is the operator-locked canon number (8/10 ruling, changes ONLY on
  // an explicit operator ruling). This function only ever returns a TIER NAME
  // string ("Hall of Flow"), never the raw number, so it is not itself a leak
  // point — but any future code path that DOES need to render a number for
  // this tier must read HALL_OF_FLOW_DISPLAY, never HALL_OF_FLOW_GATE. The
  // two liquid section files' copy strings are manually kept equal to
  // HALL_OF_FLOW_DISPLAY (Shopify theme schema JSON can't import a JS
  // constant at render time) — do not hand-edit that copy without checking
  // this comment.
  var HALL_OF_FLOW_GATE = 7.5; // model-calibration threshold, 0-10 scale — tune freely, ratio-match server.js's HALL_OF_FLOW_GATE (0-100 scale) in the same edit
  // DISPLAY re-ruled 8.0 -> 7.5 by the operator 2026-08-19 ~9:57 PM CT ("lower
  // the bar seven point five or seven, whatever you think") — a knowing
  // reversal of the 8/10 lock, logged. 7.5 also ends the structural
  // contradiction the cold-read caught: the server's alltime admission gate
  // has been 7.5 since the 8/11 recalibration, so the board was admitting
  // 7.5+ entries while the copy claimed 8.0. Display and gate now agree.
  var HALL_OF_FLOW_DISPLAY = "7.5"; // operator-ruled fan-facing number (8/19) — change ONLY on an explicit operator ruling
  function saladStatus(score) {
    if (score >= HALL_OF_FLOW_GATE) return "Hall of Flow";
    if (score >= 6) return "Bender Bangs";
    if (score >= 3) return "JV Salad";
    return "Bucket-Only, Baby";
  }
  function fmtScore(score) { return Number(score).toFixed(1); }

  // ---- Fan Rank ladder (2026-07-22) ----
  // Badge + progress teaser render everywhere they appear; tier-up moment shows
  // inside the section that earned it. Data comes from /api/me and from every
  // chirp/rank/submission response (fan_rank + tier_up fields).
  function renderFanRank(fr) {
    if (!fr) return;
    document.querySelectorAll("[data-bjda-fanrank]").forEach(function (el) {
      el.textContent = "🏒 " + fr.tier_name.toUpperCase() + " · " + fr.points + " PTS";
      el.classList.remove("bjda-hide");
    });
    document.querySelectorAll("[data-bjda-rankprogress]").forEach(function (el) {
      el.textContent = fr.next
        ? fr.next.points_needed + " pts to " + fr.next.tier_name.toUpperCase()
        : "Hall of Fame, top of the mountain, bud";
      el.classList.remove("bjda-hide");
    });
    // DangleVerse v3 (2026-08-19): fill every Fan Rank box (top standing face +
    // the post-result box). Bar % = progress toward the NEXT tier's floor from
    // zero, derived from the payload alone (points + points_needed) so no tier
    // threshold is ever duplicated client-side — rank.js stays the one source.
    var pct = fr.next
      ? Math.max(4, Math.min(100, Math.round(100 * fr.points / (fr.points + fr.next.points_needed))))
      : 100;
    document.querySelectorAll("[data-bjdv-fanrank]").forEach(function (box) {
      var t = box.querySelector("[data-bjdv-tier]"); if (t) t.textContent = fr.tier_name;
      var p = box.querySelector("[data-bjdv-pts]"); if (p) p.textContent = fr.points;
      var b = box.querySelector("[data-bjdv-bar]"); if (b) b.style.width = pct + "%";
      var n = box.querySelector("[data-bjdv-next]");
      if (n) n.textContent = fr.next
        ? fr.next.points_needed + " pts to " + fr.next.tier_name
        : "Hall of Fame, top of the mountain, bud";
    });
    // Cache for the visible points-delta toast (see the rank handler): the
    // delta is computed against this BEFORE the new payload overwrites it.
    renderFanRank._pts = fr.points;
  }
  function showTierUp(root, tu) {
    var el = $("[data-bjda-tierup]", root);
    if (!el || !tu) return;
    $("[data-bjda-tierup-name]", el).textContent = tu.tier_name.toUpperCase();
    $("[data-bjda-tierup-line]", el).textContent = tu.line || "";
    el._tu = tu;
    show(el);
  }
  function handleRank(root, body) {
    if (!body) return;
    if (body.fan_rank) renderFanRank(body.fan_rank);
    if (body.tier_up) showTierUp(root, body.tier_up);
  }
  // Tier-up share card (delegated — the button lives inside the tier-up banner).
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-bjda-share-tier]");
    if (!b) return;
    var el = b.closest("[data-bjda-tierup]");
    if (el && el._tu) {
      shareCard({
        eyebrow: "FAN RANK ⚡ BIG JOHN DANGLES",
        title: el._tu.tier_name.toUpperCase() + ".",
        text: el._tu.line || "Moved up the ladder.",
        accent: "#E6B73C",
        slug: "fanrank",
      });
    }
  });

  // ---- share card (canvas -> Web Share / download) ----
  function wrapText(ctx, text, x, y, maxW, lh) {
    var words = text.split(" "), line = "", yy = y;
    for (var i = 0; i < words.length; i++) {
      var test = line + words[i] + " ";
      if (ctx.measureText(test).width > maxW && line) {
        ctx.fillText(line.trim(), x, yy); line = words[i] + " "; yy += lh;
      } else line = test;
    }
    ctx.fillText(line.trim(), x, yy);
    return yy;
  }
  function shareCard(opts) {
    // format "story" = 9:16 (1080x1920) for TikTok/Reels/Stories; default = 1:1 group-chat square.
    var story = opts.format === "story";
    var W = 1080, H = story ? 1920 : 1080;
    var c = document.createElement("canvas");
    c.width = W; c.height = H;
    var x = c.getContext("2d");
    x.fillStyle = "#0A0A0A"; x.fillRect(0, 0, W, H);
    var g1 = x.createRadialGradient(920, 60, 0, 920, 60, story ? 1000 : 700);
    g1.addColorStop(0, "rgba(255,10,122,.28)"); g1.addColorStop(1, "rgba(255,10,122,0)");
    x.fillStyle = g1; x.fillRect(0, 0, W, H);
    var g2 = x.createRadialGradient(80, H - 100, 0, 80, H - 100, story ? 1000 : 700);
    g2.addColorStop(0, "rgba(0,168,255,.22)"); g2.addColorStop(1, "rgba(0,168,255,0)");
    x.fillStyle = g2; x.fillRect(0, 0, W, H);

    var top = story ? 260 : 0; // story card centers the content block vertically-ish
    x.fillStyle = "#E6B73C"; x.font = "800 30px system-ui,sans-serif";
    x.fillText((opts.eyebrow || "BIG JOHN DANGLES").toUpperCase(), 70, top + 110);
    x.fillStyle = opts.accent || "#FF0A7A";
    x.font = "400 " + (story ? 110 : 92) + "px Anton, Impact, sans-serif";
    x.fillText(opts.title, 66, top + (story ? 240 : 210));

    if (typeof opts.score === "number") {
      x.fillStyle = "#00A8FF"; x.font = "400 " + (story ? 300 : 220) + "px Anton, Impact, sans-serif";
      x.fillText(fmtScore(opts.score), 70, top + (story ? 580 : 470));
      x.fillStyle = "rgba(247,247,250,.5)"; x.font = "800 40px system-ui,sans-serif";
      x.fillText("/ 10, " + saladStatus(opts.score).toUpperCase(), 70, top + (story ? 650 : 530));
    }
    x.fillStyle = "#F7F7FA"; x.font = "600 " + (story ? 52 : 44) + "px Georgia, serif";
    wrapText(x, "“" + opts.text + "”", 70,
      top + (typeof opts.score === "number" ? (story ? 780 : 640) : (story ? 420 : 380)),
      940, story ? 74 : 62);

    // Challenge-line footer (2026-08-18, Direction A, operator-picked — the
    // deferred challenge-line-on-card item, proposed and approved in Phase 0):
    // a scored card carries the score to beat + a short path that lands the
    // buddy on the game, not the homepage. /flow is a Shopify URL redirect to
    // /pages/arcade — created at promote time, BEFORE this ships to live.
    if (typeof opts.score === "number") {
      x.fillStyle = "#F7F7FA"; x.font = "800 34px system-ui,sans-serif";
      x.fillText("THINK YOU BEAT " + fmtScore(opts.score) + "? PROVE IT", 70, H - 132);
      x.fillStyle = "#E6B73C"; x.font = "800 34px system-ui,sans-serif";
      x.fillText("BIGJOHNDANGLES.COM/FLOW", 70, H - 80);
    } else {
      x.fillStyle = "rgba(247,247,250,.55)"; x.font = "800 34px system-ui,sans-serif";
      x.fillText("BIGJOHNDANGLES.COM/FLOW", 70, H - 80);
    }
    x.fillStyle = "#FF0A7A"; x.fillText("⚡", 980, H - 80);

    c.toBlob(function (blob) {
      var file = new File([blob], "bjd-" + (opts.slug || "chirp") + ".png", { type: "image/png" });
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        navigator.share({ files: [file], title: "Big John Dangles" }).catch(function () {});
      } else {
        var a = document.createElement("a");
        a.href = URL.createObjectURL(blob); a.download = file.name; a.click();
        setTimeout(function () { URL.revokeObjectURL(a.href); }, 5000);
      }
    }, "image/png");
  }

  // dev-unlock removed 2026-08-18: the last remnant of the 8/04-pulled paywall.

  // INLINE MODE (2026-08-18, Direction A, operator-picked): the gate no longer
  // hides the app content behind a separate "LET'S GO" screen — it renders as a
  // checkbox row beside the submit button. The consent SEMANTICS are unchanged:
  // same explicit affirmative checkbox, same auditable POST /api/consent record,
  // still written server-side BEFORE any action route runs (ensureConsent() is
  // awaited inside the rank handler, ahead of /api/rank-flow). localStorage
  // stays a UX cache only; the server remains the source of truth and the 403
  // consent_required retry path below still re-surfaces the box.
  function showConsentGate(root) {
    var gate = $("[data-bjda-consent]", root);
    if (!gate) return;
    try { localStorage.removeItem("bjda_consent_" + CFG.cid); } catch (e) {}
    show(gate);
  }
  function initConsentGate(root) {
    if (!root || !CFG.loggedIn) return;
    var gate = $("[data-bjda-consent]", root);
    var content = $("[data-bjda-appcontent]", root);
    if (!gate || !content) return;
    var key = "bjda_consent_" + CFG.cid;
    var already = false;
    try { already = localStorage.getItem(key) === "1"; } catch (e) {}
    show(content);
    if (already) { hide(gate); return; }
    show(gate);
  }
  // Returns Promise<boolean>: true = a server-side consent record exists (cached
  // earlier, or just written). false = box unchecked or the POST failed — the
  // caller must NOT proceed with the action.
  function ensureConsent(root) {
    var gate = $("[data-bjda-consent]", root);
    // FAIL CLOSED on missing markup (Pavel hardening note, 2026-08-18): a variant
    // that ships without the consent box must not silently skip the client POST.
    // A HIDDEN gate means consent was already recorded; an ABSENT gate is a bug.
    if (!gate) { setStatus(root, "Consent box missing. That's on us, not you.", true); return Promise.resolve(false); }
    if (gate.classList.contains("bjda-hide")) return Promise.resolve(true);
    var check = $("[data-bjda-consent-check]", gate);
    if (!check || !check.checked) {
      gate.classList.add("flash");
      setTimeout(function () { gate.classList.remove("flash"); }, 1200);
      setStatus(root, "Tick the box first, bud.", true);
      if (check) check.focus();
      return Promise.resolve(false);
    }
    return api("/api/consent", {}).then(function (r) {
      if (r.status === 200 && r.body && r.body.ok) {
        try { localStorage.setItem("bjda_consent_" + CFG.cid, "1"); } catch (e) {}
        hide(gate);
        setStatus(root, "");
        return true;
      }
      setStatus(root, "Didn't go through, bud. Try again.", true);
      return false;
    }).catch(function () {
      setStatus(root, "Network's in the penalty box, try again.", true);
      return false;
    });
  }
  // Called from every action handler's response branch: if the server refused
  // for lack of a consent record (stale/cleared/spoofed cache, wrong device),
  // re-show the gate instead of surfacing a generic "engine hiccup" error.
  // Returns true if it handled the response (caller should stop processing).
  function requireConsentRetry(root, r) {
    if (r.status === 403 && r.body && r.body.error === "consent_required") {
      showConsentGate(root);
      setStatus(root, "Tick the box first, bud.", true);
      return true;
    }
    return false;
  }

  // Handle pre-fill (2026-08-12, operator-approved, all 3 boards) — fixes fans
  // re-typing their board display name every submit, which was fragmenting one
  // fan across several near-identical handles on the same board. Only fills an
  // EMPTY input, never overwrites something the fan is actively typing — this
  // matters because refreshMe() re-runs after every rank/chirp/submission, not
  // just on first load. Scoped to `root` so calling it from chirpRoot only ever
  // touches the 2 inputs that actually live there (subhandle/battle-handle) and
  // calling it from flowRoot only touches the 1 that lives there (handle) — the
  // selector that doesn't exist in a given root is just a no-op find().
  function prefillHandle(root, sel, val) {
    if (!val) return;
    var el = $(sel, root);
    if (el && !el.value) el.value = val;
  }

  // ---- free-state hint + Fan Rank badge fill ----
  function refreshMe(root) {
    if (!CFG.loggedIn) return;
    var hint = $("[data-bjda-freestate]", root);
    var kind = hint ? hint.getAttribute("data-bjda-freestate") : null;
    if (kind === "rank" && hint) {
      hint.innerHTML = "Flow ranks are <b>on the house</b>, fire away, bud";
    }
    if (kind === "chirp" && hint) {
      hint.innerHTML = "Chirps are <b>on the house</b>, fire away, bud";
    }
    // Always hit /api/me: the Fan Rank badge (2026-07-22) needs it on every surface.
    api("/api/me", {}).then(function (r) {
      if (r.status !== 200) return;
      if (r.body.fan_rank) renderFanRank(r.body.fan_rank);
      if (r.body.handles) {
        prefillHandle(root, "[data-bjda-handle]", r.body.handles.flow_ranks);
        prefillHandle(root, "[data-bjda-subhandle]", r.body.handles.submissions);
        prefillHandle(root, "[data-bjda-battle-handle]", r.body.handles.chirps);
      }
      // DangleVerse v5 fix #1 (2026-08-21, morning-feedback pass): the v3/v4
      // two-faces swap fired the big WELCOME BACK headline for ANY remembered
      // identity with a claimed handle — including an anon guest's saved
      // browser cookie, not just a real signed-in Shopify account. That's the
      // exact root cause of "how does it know that's me?": the site was
      // claiming familiarity it hadn't earned. Now three distinct states,
      // same handles payload (no new endpoint):
      //   - REAL CUSTOMER + handle -> big WELCOME BACK headline (orientation
      //     hidden), Fan Rank box shown.
      //   - GUEST (not CFG.isCustomer) + handle -> orientation STAYS, small
      //     "Playing as {handle} (guest) · Not you?" line under the Fan Rank
      //     box instead of a headline. Fan Rank box still shown — the guest's
      //     points are real earned progress, not a fake-familiarity claim.
      //   - No handle at all (cold stranger OR a fan who hasn't opted a
      //     handle onto any board yet) -> nothing personal renders.
      var h = r.body.handles && r.body.handles.flow_ranks;
      var back = document.querySelector("[data-bjdv-back]");
      var guestline = document.querySelector("[data-bjdv-guestline]");
      var orient = document.querySelector("[data-bjdv-orient]");
      var fanrankBox = document.querySelector("[data-bjdv-fanrank]");
      if (h && CFG.isCustomer) {
        if (back) {
          var hn = back.querySelector("[data-bjdv-handle]");
          if (hn) hn.textContent = h;
          back.classList.remove("bjda-hide");
        }
        if (orient) orient.classList.add("bjda-hide");
        if (guestline) guestline.classList.add("bjda-hide");
        if (fanrankBox) fanrankBox.classList.remove("bjda-hide");
      } else if (h && !CFG.isCustomer) {
        if (guestline) {
          var gh = guestline.querySelector("[data-bjdv-guest-handle]");
          if (gh) gh.textContent = h;
          guestline.classList.remove("bjda-hide");
        }
        if (back) back.classList.add("bjda-hide");
        // orientation heading stays visible for a guest — no headline swap
        if (fanrankBox) fanrankBox.classList.remove("bjda-hide");
      } else {
        if (back) back.classList.add("bjda-hide");
        if (guestline) guestline.classList.add("bjda-hide");
        if (fanrankBox) fanrankBox.classList.add("bjda-hide");
      }
    }).catch(function () {});
  }

  // CHIRP ME removed 2026-08-18 (Direction A, operator-picked): the page was
  // 404 in production and the chirp monetization it fed was ruled out 8/04.
  // Full code lives in git history (commit d24fb48f and earlier).
  //
  // ================= GLOVES OFF (restored Chirp Me) =================
  // RESTORED 2026-08-19 per operator ruling 2:27 PM CT — a knowing, logged
  // reversal of the 8/18 deletion. Source: this file's own d24fb48f Chirp Me
  // block, verbatim except: (1) both action handlers now run through
  // ensureConsent() first (Direction A inline-consent model — same record,
  // written before the action, no separate GO screen); (2) bindDevUnlock()
  // dropped (the function was deleted 8/18 with the paywall remnant);
  // (3) share-card branding follows the ruled surface name, Gloves Off.
  // The backend endpoints were never deleted; this block talks to the same
  // live /api/chirp + /api/submit-chirp it always did.
  var chirpRoot = document.querySelector("[data-bjda-app='chirp']");
  if (chirpRoot && CFG.loggedIn) {
    initConsentGate(chirpRoot);
    var chirpMode = "text";
    chirpRoot.addEventListener("click", function (e) {
      var chip = e.target.closest(".bjda-chip[data-mode]");
      if (chip && !chip.disabled) {
        chirpMode = chip.getAttribute("data-mode");
        chirpRoot.querySelectorAll(".bjda-chip[data-mode]").forEach(function (c) {
          c.setAttribute("aria-pressed", c === chip ? "true" : "false");
        });
      }
    });

    // Chirp Battle toggle (2026-08-05): demoted from a tab to a single button
    // beside the submit box. Shows/hides the Battle mini-generator in place.
    var battleBtn = $("[data-bjda-battle-toggle]", chirpRoot);
    var battlePane = $("[data-pane='get']", chirpRoot);
    if (battleBtn && battlePane) {
      battleBtn.addEventListener("click", function () {
        var opening = battlePane.classList.contains("bjda-hide");
        battlePane.classList.toggle("bjda-hide", !opening);
        battleBtn.setAttribute("aria-expanded", opening ? "true" : "false");
        // [COPY: provisional real words (2026-08-19 v4) — Bobby's pass owed. Closed
        // label must match the markup default in bjd-gloves-off.liquid.]
        battleBtn.textContent = opening ? "Close the chirp writer" : "No chirp on you? BJD writes one ⚡";
      });
    }

    // Battle board opt-in (2026-08-06) — unchecked by default; the handle
    // field only appears once the fan actively checks the box.
    var battleOptInCheck = $("[data-bjda-battle-optin-check]", chirpRoot);
    var battleHandleWrap = $("[data-bjda-battle-handle-wrap]", chirpRoot);
    var battleHandleInput = $("[data-bjda-battle-handle]", chirpRoot);
    if (battleOptInCheck && battleHandleWrap) {
      battleOptInCheck.addEventListener("change", function () {
        battleHandleWrap.classList.toggle("bjda-hide", !battleOptInCheck.checked);
      });
    }

    var fireBtn = $("[data-bjda-fire]", chirpRoot);
    if (fireBtn) fireBtn.addEventListener("click", function () {
      var situation = $("[data-bjda-situation]", chirpRoot).value.trim();
      if (situation.length < 3) { setStatus(chirpRoot, "Gimme the situation first, bud.", true); return; }
      var battleOptedIn = !!(battleOptInCheck && battleOptInCheck.checked);
      var battleHandle = battleOptedIn && battleHandleInput ? battleHandleInput.value.trim() : "";
      if (battleOptedIn && battleHandle.length < 2) {
        // [COPY: provisional — Bobby's pass owed. NEVER render a bracket tag fan-facing.]
        setStatus(chirpRoot, "Pick a handle first, bud.", true);
        return;
      }
      // Inline consent (2026-08-19 restore): record consent BEFORE the action
      // route — same ordering the old gate screen enforced, one flow now.
      ensureConsent(chirpRoot).then(function (consentOk) {
      if (!consentOk) return;
      fireBtn.disabled = true;
      setStatus(chirpRoot, chirpMode === "voice" ? "BJD's warmin' up the pipes…" : "BJD's cookin'…");
      hide($("[data-bjda-result]", chirpRoot));
      hide($("[data-bjda-tierup]", chirpRoot));
      api("/api/chirp", { situation: situation, mode: chirpMode, handle: battleOptedIn ? battleHandle : undefined }).then(function (r) {
        fireBtn.disabled = false;
        if (requireConsentRetry(chirpRoot, r)) return;
        if (r.status === 400 && r.body && r.body.error === "bad_handle") {
          setStatus(chirpRoot, r.body.message || "Handle needs 2-24 clean characters.", true);
          return;
        }
        if (r.status === 429) {
          setStatus(chirpRoot, (r.body && r.body.message) || "Easy, bud. Come back in a bit.", true);
          return;
        }
        if (r.status !== 200) { setStatus(chirpRoot, "Engine hiccup. Give it another go.", true); return; }
        setStatus(chirpRoot, "");
        var res = $("[data-bjda-result]", chirpRoot);
        $("[data-bjda-text]", res).textContent = r.body.text;
        var wave = $(".bjda-wave", res);
        wave.classList.toggle("bjda-hide", !r.body.audio);
        res.classList.toggle("bjda-puntstate", !!r.body.punt);
        show(res);
        var tag = $("[data-bjda-ranktag]", res);
        if (tag) {
          // [COPY: provisional — Bobby's pass owed. NEVER render a bracket tag fan-facing.]
          tag.textContent = r.body.punt
            ? "BJD passed on that one, keep it at the rink"
            : (r.body.board === "pending" ? "Beef's in the queue for the show" : "");
        }
        if (r.body.audio) playAudio(r.body.audio, wave);
        res._last = r.body;
        if (!r.body.punt) { handleRank(chirpRoot, r.body); refreshMe(chirpRoot); }
        // Reset the opt-in after EVERY fire — each new setup needs its own
        // fresh, deliberate opt-in decision.
        if (battleOptInCheck) {
          battleOptInCheck.checked = false;
          if (battleHandleWrap) hide(battleHandleWrap);
          if (battleHandleInput) battleHandleInput.value = "";
        }
      }).catch(function () { fireBtn.disabled = false; setStatus(chirpRoot, "Network's in the penalty box, try again.", true); });
      }); // end ensureConsent().then
    });

    var chirpResEl = $("[data-bjda-result]", chirpRoot);
    if (chirpResEl) chirpResEl.addEventListener("click", function (e) {
      if (e.target.closest("[data-bjda-share]") && chirpResEl._last) {
        shareCard({ eyebrow: "GLOVES OFF ⚡ BIG JOHN DANGLES", title: "CHIRPED.", text: chirpResEl._last.text, accent: "#FF0A7A", slug: "glovesoff" });
      }
      if (e.target.closest("[data-bjda-share-story]") && chirpResEl._last) {
        shareCard({ eyebrow: "GLOVES OFF ⚡ BIG JOHN DANGLES", title: "CHIRPED.", text: chirpResEl._last.text, accent: "#FF0A7A", slug: "glovesoff-story", format: "story" });
      }
      if (e.target.closest("[data-bjda-replay]") && chirpResEl._last && chirpResEl._last.audio) {
        playAudio(chirpResEl._last.audio, $(".bjda-wave", chirpResEl));
      }
    });

    // The fan's OWN chirp — BJD heat-checks it; a handle queues it for review.
    var subBtn = $("[data-bjda-submit]", chirpRoot);
    if (subBtn) subBtn.addEventListener("click", function () {
      var chirp = $("[data-bjda-subchirp]", chirpRoot).value.trim();
      var context = $("[data-bjda-subcontext]", chirpRoot).value.trim();
      var handleEl = $("[data-bjda-subhandle]", chirpRoot);
      var handle = handleEl ? handleEl.value.trim() : "";
      if (chirp.length < 3) { setStatus(chirpRoot, "Type the chirp first, bud.", true); return; }
      ensureConsent(chirpRoot).then(function (consentOk) {
      if (!consentOk) return;
      subBtn.disabled = true;
      setStatus(chirpRoot, "Sendin' it up to the big man…");
      var sres = $("[data-bjda-subresult]", chirpRoot);
      var ownrow = $("[data-bjda-ownrow]", chirpRoot);
      hide(sres);
      hide(ownrow);
      api("/api/submit-chirp", { chirp: chirp, context: context, handle: handle || undefined }).then(function (r) {
        subBtn.disabled = false;
        if (requireConsentRetry(chirpRoot, r)) return;
        if (r.status === 429) { setStatus(chirpRoot, (r.body && r.body.message) || "Daily limit, bud.", true); return; }
        if (r.body && r.body.punt) {
          setStatus(chirpRoot, "");
          if (sres) {
            $("[data-bjda-subtext]", sres).textContent = r.body.text;
            $("[data-bjda-subheat]", sres).textContent = "—";
            sres.classList.add("bjda-puntstate");
            var pw = $(".bjda-wave", sres);
            pw.classList.toggle("bjda-hide", !r.body.audio);
            $("[data-bjda-subtag]", sres).textContent = "BJD passed on that one";
            hide(ownrow);
            show(sres);
            sres._last = r.body.audio ? { audio: r.body.audio } : null;
            if (r.body.audio) playAudio(r.body.audio, pw);
          }
          return;
        }
        if (r.status !== 200) { setStatus(chirpRoot, (r.body && r.body.message) || "Didn't go through. Try again.", true); return; }
        setStatus(chirpRoot, "");
        if (sres) {
          sres.classList.remove("bjda-puntstate");
          $("[data-bjda-subheat]", sres).textContent = r.body.score != null ? r.body.score : "—";
          $("[data-bjda-subtext]", sres).textContent = r.body.reaction || "In the queue for the show, bud.";
          var sw = $(".bjda-wave", sres);
          // Tap-to-play (2026-08-06): TTS fires on the tap, not on submit.
          show(sw);
          sw.classList.add("paused");
          var subReplayBtn = $("[data-bjda-subreplay]", sres);
          if (subReplayBtn) subReplayBtn.textContent = "▶ Make him say it";
          // v4 (2026-08-19): handle-carrying chirps auto-approve onto the board.
          $("[data-bjda-subtag]", sres).textContent =
            r.body.board === "approved" ? "On the board ✓"
            : r.body.board === "pending" ? "Entry in review, the crew checks every one"
            : "In the queue for the show ✓";
          if (ownrow) {
            if (r.body.board === "approved" || r.body.board === "pending") {
              $("[data-bjda-own-handle]", ownrow).textContent = handle || "you";
              $("[data-bjda-own-heat]", ownrow).innerHTML = (r.body.score != null ? r.body.score : "—") + "<small>/10</small>";
              $("[data-bjda-own-chirp]", ownrow).textContent = "“" + chirp + "”";
              var pill = ownrow.querySelector(".pill");
              if (pill) pill.textContent = r.body.board === "approved" ? "Live" : "In review";
              show(ownrow);
            } else {
              hide(ownrow);
            }
          }
          show(sres);
          sres._last = { id: r.body.id, audio: null, fetching: false };
        }
        // Cleared only on a real accept — a declined or failed attempt stays
        // in the box so the fan can edit and resend.
        $("[data-bjda-subchirp]", chirpRoot).value = "";
        $("[data-bjda-subcontext]", chirpRoot).value = "";
        handleRank(chirpRoot, r.body);
      }).catch(function () { subBtn.disabled = false; setStatus(chirpRoot, "Network's in the penalty box, try again.", true); });
      }); // end ensureConsent().then
    });

    var subRes = $("[data-bjda-subresult]", chirpRoot);
    if (subRes) subRes.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-bjda-subreplay]");
      var last = subRes._last;
      if (!btn || !last) return;
      if (last.audio) { playAudio(last.audio, $(".bjda-wave", subRes)); return; }
      if (!last.id || last.fetching) return;
      last.fetching = true;
      var wave = $(".bjda-wave", subRes);
      setStatus(chirpRoot, "Warmin' up the mic…");
      api("/api/submit-chirp/" + last.id + "/speak", {}).then(function (r) {
        last.fetching = false;
        if (r.status === 200 && r.body && r.body.audio) {
          last.audio = r.body.audio;
          setStatus(chirpRoot, "");
          btn.textContent = "↻ Replay";
          playAudio(last.audio, wave);
        } else {
          setStatus(chirpRoot, (r.body && r.body.voice_note) || "Mic's cold tonight. Your chirp still lands, just reading it instead of hearing it.", true);
        }
      }).catch(function () {
        last.fetching = false;
        setStatus(chirpRoot, "Network's in the penalty box, try again.", true);
      });
    });

    refreshMe(chirpRoot);
  }

  // ================= RANK MY FLOW =================
  var flowRoot = document.querySelector("[data-bjda-app='flow']");
  if (flowRoot && CFG.loggedIn) {
    initConsentGate(flowRoot);
    var imgData = null;
    var fileInput = $("[data-bjda-file]", flowRoot);
    $(".bjda-drop", flowRoot).addEventListener("click", function () { fileInput.click(); });
    // v4 (2026-08-19, cold-read): the primary CTA starts disabled in the
    // markup — a hot-pink "Reveal my score" that dead-ends without a photo
    // was the first thing an eager fan mashed. Enabled the moment a photo
    // lands; the no-photo click guard below stays as the backstop.
    var revealBtn = $("[data-bjda-rank]", flowRoot);
    fileInput.addEventListener("change", function () {
      var f = fileInput.files && fileInput.files[0];
      if (!f) return;
      // v5 defect #3 (2026-08-21): un-hide alongside un-disable — the button
      // starts bjda-hide in the markup now (was a visible-but-dead 0.4
      // opacity control far below the uploader before this fix).
      if (revealBtn) { revealBtn.disabled = false; revealBtn.classList.remove("bjda-hide"); }
      var img = new Image();
      img.onload = function () {
        var max = 768, w = img.width, h = img.height;
        var scale = Math.min(1, max / Math.max(w, h));
        var c = document.createElement("canvas");
        c.width = Math.round(w * scale); c.height = Math.round(h * scale);
        c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
        imgData = c.toDataURL("image/jpeg", 0.85);
        var pv = $(".bjda-preview", flowRoot);
        pv.style.display = "block";
        $("img", pv).src = imgData;
        URL.revokeObjectURL(img.src);
      };
      img.src = URL.createObjectURL(f);
    });

    // Game-show loading sequence (operator 7/08): rotating hype lines + live avatar
    // stage while the verdict cooks, then a count-up score reveal.
    var HYPE = [
      "BJD's inspectin' the salad…",
      "Measurin' the wings…",
      "Checkin' the flow-to-face ratio…",
      "Consultin' the flow gods…",
      "Runnin' it past the boys in the barn…",
      "Warmin' up the verdict…",
    ];
    function startShow(root) {
      var stage = $("[data-bjda-stage]", root);
      if (stage) { show(stage); stage.classList.add("live"); }
      var i = 0;
      setStatus(root, HYPE[0]);
      return setInterval(function () { i = (i + 1) % HYPE.length; setStatus(root, HYPE[i]); }, 1700);
    }
    function stopShow(root, timer) {
      clearInterval(timer);
      var stage = $("[data-bjda-stage]", root);
      if (stage) stage.classList.remove("live");
    }
    function countUp(el, target) {
      var t0 = null;
      function step(ts) {
        if (!t0) t0 = ts;
        var p = Math.min(1, (ts - t0) / 1400);
        var eased = 1 - Math.pow(1 - p, 3);
        el.innerHTML = (eased * target).toFixed(1) + "<small>/10</small>";
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    var rankBtn = $("[data-bjda-rank]", flowRoot);
    rankBtn.addEventListener("click", function () {
      if (!imgData) { setStatus(flowRoot, "Drop the flow pic first, bud.", true); return; }
      // Inline consent (2026-08-18): record consent BEFORE the action route —
      // same ordering the old gate screen enforced, now one flow, no extra screen.
      ensureConsent(flowRoot).then(function (consentOk) {
      if (!consentOk) return;
      rankBtn.disabled = true;
      hide($("[data-bjda-result]", flowRoot));
      hide($("[data-bjda-tierup]", flowRoot));
      hide($("[data-bjdv-ptstoast]", flowRoot)); // v3: stale delta never carries into a new run
      $(".bjda-scorecard", flowRoot).classList.remove("show");
      var showTimer = startShow(flowRoot);
      api("/api/rank-flow", { image: imgData }).then(function (r) {
        stopShow(flowRoot, showTimer);
        rankBtn.disabled = false;
        if (requireConsentRetry(flowRoot, r)) return;
        if (r.status === 429) { setStatus(flowRoot, r.body.message || "Easy, bud. Come back in a bit.", true); return; }
        if (r.status !== 200) { setStatus(flowRoot, "Engine hiccup. Give it another go.", true); return; }
        setStatus(flowRoot, "");
        var res = $("[data-bjda-result]", flowRoot);
        var board = $("[data-bjda-board]", flowRoot);
        hide(board);
        if (r.body.punt) {
          $("[data-bjda-text]", res).textContent = r.body.text;
          var pwave = $(".bjda-wave", res);
          // Voiced punts (2026-07-22): the refusal line plays out loud too.
          pwave.classList.toggle("bjda-hide", !r.body.audio);
          res.classList.add("bjda-puntstate");
          var ptag = $("[data-bjda-ranktag]", res);
          if (ptag) ptag.textContent = "BJD passed on that one";
          show(res);
          if (r.body.audio) playAudio(r.body.audio, pwave);
          // keep replay working for the voiced punt; share falls back to the punt line
          res._last = r.body.audio ? { audio: r.body.audio, roast: r.body.text } : null;
          return;
        }
        res.classList.remove("bjda-puntstate");
        var sc = $(".bjda-scorecard", flowRoot);
        // Stamped BEFORE classList.add("show") triggers any class-change
        // observer (2026-08-08) — bjd-rank-my-flow-rink.liquid's sound engine
        // used to fire the full goal horn on ANY score the instant this class
        // changed, because the DOM held nothing but a "show"/no-show flag.
        // The count-up animation below only eases the DISPLAYED digits; the
        // real score has to be readable synchronously, before that starts.
        sc.dataset.score = r.body.score;
        sc.classList.add("show");
        countUp($("[data-bjda-score]", sc), Number(r.body.score));
        $("[data-bjda-salad]", sc).textContent = r.body.salad_status || saladStatus(r.body.score);
        $("[data-bjda-text]", res).textContent = r.body.roast;
        var wave = $(".bjda-wave", res);
        // 2026-08-06: was an unconditional remove("bjda-hide") — a degraded
        // response (TTS kill switch / global ceiling / credits-low) sends
        // audio:null with the verdict text still populated, and showed a
        // wave icon that looked playable but never made sound. Same
        // toggle-on-audio-presence pattern the Chirp Me / Chirp Battle
        // panes already use (see the .bjda-wave toggles above in this file).
        wave.classList.toggle("bjda-hide", !r.body.audio);
        show(res);
        var tag = $("[data-bjda-ranktag]", res);
        if (tag) tag.textContent = "";
        if (r.body.audio) playAudio(r.body.audio, wave);
        res._last = r.body;
        // DangleVerse v3 (2026-08-19): visible points moment. The delta is the
        // fan's REAL gain (new total minus the cached total renderFanRank saw
        // last), so a daily-capped play shows nothing and a streak bonus shows
        // its true combined number — never a hardcoded "+10" the server didn't
        // actually pay. Cached total exists because refreshMe() runs at init.
        var prevPts = renderFanRank._pts;
        handleRank(flowRoot, r.body);
        if (r.body.fan_rank && typeof prevPts === "number") {
          var delta = r.body.fan_rank.points - prevPts;
          var toast = $("[data-bjdv-ptstoast]", flowRoot);
          if (toast && delta > 0) {
            var num = $("[data-bjdv-ptsnum]", toast);
            if (num) num.textContent = delta;
            show(toast);
          }
        }
        var rankBox = $("[data-bjdv-rankbox]", flowRoot);
        if (rankBox && r.body.fan_rank) show(rankBox);
        // Legendary Lettuce opt-in — only offered once the rank exists server-side.
        if (r.body.rankId && board) {
          var note = $("[data-bjda-board-note]", board);
          if (note) { note.textContent = ""; note.className = "note"; }
          var btn = $("[data-bjda-board-submit]", board);
          if (btn) { btn.disabled = false; }
          show(board);
        }
        refreshMe(flowRoot);
      }).catch(function () { stopShow(flowRoot, showTimer); rankBtn.disabled = false; setStatus(flowRoot, "Network's in the penalty box, try again.", true); });
      }); // end ensureConsent().then
    });

    // Legendary Lettuce board opt-in (2026-07-08). Opt-in ONLY — nothing is posted
    // automatically; the entry is pending until a human approves it.
    var boardEl = $("[data-bjda-board]", flowRoot);
    if (boardEl) {
      var boardBtn = $("[data-bjda-board-submit]", boardEl);
      boardBtn.addEventListener("click", function () {
        var res = $("[data-bjda-result]", flowRoot);
        var note = $("[data-bjda-board-note]", boardEl);
        var setNote = function (msg, cls) { note.textContent = msg; note.className = "note" + (cls ? " " + cls : ""); };
        if (!res._last || !res._last.rankId) { setNote("Rank a flow first, bud.", "err"); return; }
        var handle = $("[data-bjda-handle]", boardEl).value.trim();
        if (handle.length < 2) { setNote("Pick a handle first, not your real name.", "err"); return; }
        boardBtn.disabled = true;
        setNote("Sendin' it to the review crew…");
        api("/api/board/submit", { handle: handle, rankId: res._last.rankId }).then(function (r) {
          if (r.status === 200 && r.body.accepted) {
            // v4 (2026-08-19, operator ruling): entries auto-approve — the card
            // is ON the board the moment it lands. [COPY: provisional — Bobby.]
            setNote(r.body.status === "approved"
              ? "You're ON the board, bud ✓. Go look."
              : "You're in the queue, bud ✓. The crew's takin' a look first.", "ok");
            handleRank(flowRoot, r.body); // board award pays instantly now — show it
            return; // keep button disabled: one submit per rank
          }
          boardBtn.disabled = false;
          if (r.body && r.body.punt) { setNote("That handle's not makin' the cut, bud. Try another.", "err"); return; }
          if (r.status === 409) { setNote("That rank's already in the system, bud.", "err"); return; }
          setNote((r.body && r.body.message) || "Didn't go through. Try again.", "err");
        }).catch(function () { boardBtn.disabled = false; setNote("Network's in the penalty box, try again.", "err"); });
      });
    }

    var fres = $("[data-bjda-result]", flowRoot);
    fres.addEventListener("click", function (e) {
      if (e.target.closest("[data-bjda-share]") && fres._last) {
        shareCard({ eyebrow: "RANK MY FLOW ⚡ BIG JOHN DANGLES", title: "FLOW RANKED.", text: fres._last.roast, score: fres._last.score, accent: "#00A8FF", slug: "flow" });
      }
      if (e.target.closest("[data-bjda-share-story]") && fres._last) {
        shareCard({ eyebrow: "RANK MY FLOW ⚡ BIG JOHN DANGLES", title: "FLOW RANKED.", text: fres._last.roast, score: fres._last.score, accent: "#00A8FF", slug: "flow-story", format: "story" });
      }
      if (e.target.closest("[data-bjda-replay]") && fres._last && fres._last.audio) {
        playAudio(fres._last.audio, $(".bjda-wave", fres));
      }
    });

    refreshMe(flowRoot);
  }

  // THE BEAKDOWN board removed 2026-08-18 with Chirp Me (Direction A).

  // ================= BUBBLE HOCKEY (2026-08-19, game two) =================
  // The game runs dependency-free inside an iframe (theme asset) and reports
  // its final via postMessage — see apps/bubble-hockey-3d src/main.js. Skill
  // pays, participation doesn't: only a WIN against the computer calls the
  // award endpoint (chirp-api v0.23+; an older backend 404s and this stays a
  // silent no-op — the game itself is unaffected). The message is trusted
  // only from the panel's own iframe window.
  window.addEventListener("message", function (ev) {
    var d = ev.data;
    if (!d || d.type !== "bjd-bubble-final") return;
    var frame = document.querySelector("[data-bjdv-bubble-iframe]");
    if (!frame || ev.source !== frame.contentWindow) return;
    if (d.mode !== "CPU" || !d.winner || d.winner !== d.humanTeam) return;
    var prevPts = renderFanRank._pts;
    api("/api/bubble/win", { difficulty: d.difficulty }).then(function (r) {
      if (r.status !== 200 || !r.body) return;
      if (r.body.fan_rank) renderFanRank(r.body.fan_rank);
      var note = document.querySelector("[data-bjdv-bubble-note]");
      if (note && r.body.fan_rank && typeof prevPts === "number") {
        var delta = r.body.fan_rank.points - prevPts;
        if (delta > 0) {
          note.textContent = "⚡ +" + delta + " points, bud";
          note.classList.remove("bjda-hide");
        }
      }
    }).catch(function () {});
  });

  // ================= LEGENDARY LETTUCE ARENA =================
  // Public read — works logged-out (GET /api/board needs no signature).
  document.querySelectorAll("[data-bjda-lettuce]").forEach(function (boardRoot) {
    // Sandbox phase: the API sends the flow photo (data URL). Strict prefix check
    // before it touches the DOM; the img never renders anything non-image.
    function safePhoto(container, e) {
      // 2026-08-23 live fix: the API moved board photos from inline data: URLs
      // to bucket signed https URLs on 8/12 (image-storage-off-Postgres), but
      // this prefix check still only accepted data: - so when the operator
      // turned BOARD_SHOW_PHOTOS back on, every photo slot rendered empty.
      // Accept https too; both land only in img.src, never in markup.
      var okPhoto = container && e.photo && typeof e.photo === "string" &&
        (e.photo.indexOf("data:image/") === 0 || e.photo.indexOf("https://") === 0);
      if (okPhoto) {
        var img = document.createElement("img");
        img.src = e.photo;
        img.alt = "";
        img.loading = "eager"; // 2026-08-23: board holds <=10 thumbs; lazy added nothing but delay
        container.appendChild(img);
      }
    }
    function saladRow(e) {
      return '<li><span class="rk">' + e.rank + '</span><span class="ph"></span><span class="hd"></span><span class="tr"></span><span class="ss"></span><span class="scr">' + fmtScore(e.score) + '</span></li>';
    }
    function fillList(listEl, emptyMsg, entries) {
      if (!listEl) return;
      if (!entries.length) {
        listEl.innerHTML = '<li class="empty">' + emptyMsg + "</li>";
        return;
      }
      listEl.innerHTML = entries.map(saladRow).join("");
      // textContent assignment keeps fan-supplied handles inert (no HTML injection).
      listEl.querySelectorAll("li").forEach(function (li, i) {
        var e = entries[i];
        if (!e) return;
        li.querySelector(".hd").textContent = e.handle;
        li.querySelector(".tr").textContent = e.fan_rank || ""; // Fan Rank tier chip (empty = hidden via CSS)
        li.querySelector(".ss").textContent = e.salad_status;
        safePhoto(li.querySelector(".ph"), e);
      });
    }
    function fillPodium(podEl, entries) {
      if (!podEl) return entries;
      var top3 = entries.slice(0, 3);
      top3.forEach(function (e, i) {
        var slot = podEl.querySelector('[data-slot="' + (i + 1) + '"]');
        if (!slot) return;
        slot.classList.add("on");
        slot.querySelector(".hd").textContent = e.handle;
        slot.querySelector(".scr").textContent = fmtScore(e.score);
        safePhoto(slot.querySelector(".ph"), e);
      });
      return entries.slice(3);
    }
    // n=1 (and low-N) duplicate-display fix (2026-08-09): weekly and alltime
    // are two INDEPENDENT windows on the same underlying data — with few
    // total submissions, the same fan's card is often the top of BOTH at
    // once, so it rendered twice (once in "This week's pack," once in "The
    // Legends insert set"). Correct per-window data, reads as broken. Fetch
    // both windows together, then exclude from "alltime" any handle already
    // showing in "weekly" (case-insensitive, matches how the server itself
    // dedupes — see getBoard()'s lower(handle) key) so a fan never sees
    // their own card twice. If that leaves alltime empty, the section's
    // existing empty-state copy already covers it — no new copy needed.
    Promise.all([
      fetch(CFG.api + "/api/board?window=weekly").then(function (r) { return r.json(); }).catch(function () { return { entries: [] }; }),
      fetch(CFG.api + "/api/board?window=alltime").then(function (r) { return r.json(); }).catch(function () { return { entries: [] }; }),
    ]).then(function (results) {
      var weekly = results[0].entries || [];
      var alltime = results[1].entries || [];

      var rest = fillPodium(boardRoot.querySelector("[data-bjda-podium]"), weekly);
      var weeklyListEl = boardRoot.querySelector("[data-bjda-lettuce-weekly]");
      if (weekly.length && !rest.length) { if (weeklyListEl) weeklyListEl.innerHTML = ""; }
      else fillList(weeklyListEl, boardRoot.getAttribute("data-empty-weekly") || "Nobody's on the board yet. Be the first, bud.", weekly.length ? rest : []);

      var shownThisWeek = {};
      weekly.forEach(function (e) { if (e && e.handle) shownThisWeek[String(e.handle).toLowerCase()] = true; });
      var alltimeFiltered = alltime.filter(function (e) { return !(e && e.handle && shownThisWeek[String(e.handle).toLowerCase()]); });
      fillList(boardRoot.querySelector("[data-bjda-lettuce-alltime]"), boardRoot.getAttribute("data-empty-alltime") || "The hall's still empty. History's waitin'.", alltimeFiltered);
    });
  });

  // ================= DANGLEVERSE SCOREBOARD (v5, 2026-08-21) =================
  // Universal points board — GET /api/points-board — fed by all three games
  // (chirp-api/lib/rank.js AWARDS all funnel into the one fans.points
  // currency). Buddy view (my rank + nearest neighbors) renders FIRST, per
  // the operator's 8/12 ruling that the rival that matters is the fan next
  // to you, not the board leader; the global top 10 renders below it. Works
  // logged-out for the top10/contention read; identity (CFG.cid/email/sig,
  // sent as query params since this is a GET) adds the buddy view when the
  // caller has a claimed handle and points. Public read, same posture as
  // the Legendary Lettuce arena above — no signature required to view.
  document.querySelectorAll("[data-bjdv-scoreboard]").forEach(function (boardRoot) {
    function ptsRow(e, isMe) {
      return '<li class="' + (isMe ? "me" : "") + '"><span class="rk">' + e.rank +
        '</span><span class="hd"></span><span class="tr"></span><span class="pt">' + e.points + " PTS</span></li>";
    }
    function fillPtsList(listEl, emptyMsg, entries, meCid) {
      if (!listEl) return;
      if (!entries || !entries.length) {
        listEl.innerHTML = '<li class="empty">' + emptyMsg + "</li>";
        return;
      }
      listEl.innerHTML = entries.map(function (e) { return ptsRow(e, !!e.is_me); }).join("");
      listEl.querySelectorAll("li").forEach(function (li, i) {
        var e = entries[i];
        if (!e) return;
        var hd = li.querySelector(".hd");
        if (hd) hd.textContent = e.handle;
        var tr = li.querySelector(".tr");
        if (tr) tr.textContent = e.fan_rank || "";
      });
    }
    var cfg = window.BJD_ARCADE || {};
    var url = cfg.api + "/api/points-board?limit=10";
    if (cfg.cid) {
      url += "&cid=" + encodeURIComponent(cfg.cid) + "&email=" + encodeURIComponent(cfg.email || "") + "&sig=" + encodeURIComponent(cfg.sig || "");
    }
    // v5 defect #4 (2026-08-21, operator walkthrough): a FETCH FAILURE (the
    // endpoint 404ing — e.g. this dev theme pointed at production before
    // /api/points-board has promoted past staging — or a real network
    // error) must never render through the SAME path as a genuinely empty
    // board. The old code caught the failure and substituted a fake
    // `{top10:[], contention:null, buddy:null}` payload that flowed into
    // fillPtsList()'s normal empty-state copy ("Nobody's claimed the board
    // yet") — an error dressed up as an honest empty state, a false claim.
    // Now failure gets its OWN branch with its own quiet, distinct line.
    fetch(url).then(function (r) {
      if (!r.ok) throw new Error("points-board http " + r.status);
      return r.json();
    }).then(function (j) {
      j = j || {};
      var buddyList = boardRoot.querySelector("[data-bjdv-sb-buddy]");
      var buddyWrap = boardRoot.querySelector("[data-bjdv-sb-buddy-wrap]");
      if (buddyWrap) buddyWrap.classList.remove("bjda-hide");
      if (j.buddy && j.buddy.my_rank && j.buddy.entries && j.buddy.entries.length) {
        fillPtsList(buddyList, "", j.buddy.entries, cfg.cid);
      } else if (j.buddy && j.buddy.my_rank == null) {
        // Real points, no rank yet (no handle claimed on any board) —
        // never fabricate a rank; show the fan's real total and a
        // play-to-claim-your-spot nudge instead of a fake position.
        fillPtsList(buddyList, boardRoot.getAttribute("data-empty-buddy-unranked") || "Play a game and claim a handle to show up here.", [], cfg.cid);
      } else {
        if (buddyWrap) buddyWrap.classList.add("bjda-hide");
      }
      fillPtsList(boardRoot.querySelector("[data-bjdv-sb-top10]"), boardRoot.getAttribute("data-empty-top10") || "Nobody's claimed the board yet. First one up owns it.", j.top10 || []);
      var contentionEl = boardRoot.querySelector("[data-bjdv-sb-contention]");
      if (contentionEl) {
        if (j.contention && j.contention.points != null) {
          contentionEl.textContent = (boardRoot.getAttribute("data-contention-template") || "Top 10 starts at {n} pts right now").replace("{n}", j.contention.points);
          contentionEl.classList.remove("bjda-hide");
        } else {
          contentionEl.classList.add("bjda-hide");
        }
      }
    }).catch(function () {
      // Distinct error state — never the empty-board copy. [COPY: Bobby —
      // provisional real words below, tag only in this comment.]
      var buddyWrap = boardRoot.querySelector("[data-bjdv-sb-buddy-wrap]");
      if (buddyWrap) buddyWrap.classList.add("bjda-hide");
      var top10El = boardRoot.querySelector("[data-bjdv-sb-top10]");
      if (top10El) {
        top10El.innerHTML = '<li class="empty err">' +
          (boardRoot.getAttribute("data-error-line") || "Board's warming up. Check back in a bit.") + "</li>";
      }
      var contentionEl2 = boardRoot.querySelector("[data-bjdv-sb-contention]");
      if (contentionEl2) contentionEl2.classList.add("bjda-hide");
    });
  });
})();
